import React from 'react';
import { Button, Spinner, Alert } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

import DashboardLayout from '../components/dashboard/DashboardLayout';
import ApplicantDetailContent from '../components/ApplicantDetailContent';
import { useGetApplicantsId } from '../api/generated/arrayscapeGamingDashboardAPI';

export const ApplicantDetailPage: React.FC = () => {
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const { data: applicant, isLoading, error } = useGetApplicantsId(id, { query: { enabled: !!id } });

  return (
    <DashboardLayout scrollable>
      <>
      <Button variant="link" className="px-0 mb-1 align-self-start" onClick={() => navigate('/applicants')}>
        <i className="bi bi-arrow-left me-1" />Back to applicants
      </Button>
      <h1 className="h3 mb-4 text-body fw-bold">Applicant</h1>

      {isLoading && <Spinner animation="border" />}
      {error && <Alert variant="danger">Failed to load applicant.</Alert>}
      {applicant && <ApplicantDetailContent applicant={applicant} onDeleted={() => navigate('/applicants')} />}
      </>
    </DashboardLayout>
  );
};

export default ApplicantDetailPage;
